/* eslint-disable no-useless-escape */
export const VALID_TEXT = /[^ A-Za-z0-9.*+=\-\/]/;
